"use client"
import React from "react";
import style from "./LoadingBar.module.scss";



const LoadingBar = () =>  <div id={'globLoadingIndicator'} className={style.loader} />

export default LoadingBar;